import React from 'react';
import { HelpCircle } from 'lucide-react';

const FlowAdjuster = ({ value, onChange }) => {
  const progressWidth = ((value - 8) / (11 - 8)) * 100;

  return (
    <div className="space-y-2 w-full">
      <div className="flex items-center gap-2">
        {/* Left side - Label and Help */}
        <div className="flex items-center gap-1 min-w-fit relative">
          <label className="text-[#EAECEF] text-xs sm:text-sm font-semibold whitespace-nowrap">
            Flow
          </label>
          <div className="relative group hidden sm:block">
            <HelpCircle
              size={14}
              className="text-[#B0B4BB] hover:text-[#EAECEF] transition-colors cursor-help"
            />
            <div className="absolute left-0 bottom-full mb-1 w-[clamp(12rem,25vw,16rem)]
                            p-2 bg-[#2C2F30] text-[#EAECEF] text-[clamp(0.75rem,1.5vw,0.875rem)]
                            rounded-lg shadow-xl border border-[#3A3D3E]
                            opacity-0 group-hover:opacity-100 transition-opacity
                            pointer-events-none z-10">
              Tweak this if you are not happy with pauses and breaks in generated speech.
              Different values will randomize this process a bit. It is only applicable for
              longer sentences and not for short sentences.
              <div className="absolute left-4 bottom-[-4px] w-2 h-2 bg-[#2C2F30]
                              border-r border-b border-[#3A3D3E] transform rotate-45">
              </div>
            </div>
          </div>
        </div>

        {/* Middle - Slider */}
        <div className="flex-1">
          <input
            type="range"
            min="8"
            max="11"
            step="1"
            value={value}
            onChange={onChange}
            className="w-full h-[0.2rem] rounded-full appearance-none cursor-pointer
                     [&::-webkit-slider-thumb]:appearance-none
                     [&::-webkit-slider-thumb]:w-[0.75rem]
                     [&::-webkit-slider-thumb]:h-[0.75rem]
                     [&::-webkit-slider-thumb]:rounded-full
                     [&::-webkit-slider-thumb]:bg-[#178A94]
                     [&::-webkit-slider-thumb]:hover:bg-[#146E75]
                     [&::-webkit-slider-thumb]:transition-colors"
            style={{
              background: `linear-gradient(to right, #EAECEF ${progressWidth}%, #181A1B ${progressWidth}%)`
            }}
          />
        </div>

        {/* Right side - Value display */}
        <span className="rounded min-w-[2.5ch] text-center font-medium
                      text-sm text-[#EAECEF] bg-[#178A94] px-2 py-0.5">
          {value}
        </span>
      </div>

      {/* Bottom labels */}
      <div className="flex justify-between text-[0.65rem] px-1 items-center">
        <div className="flex items-center">
          <span className="font-bold text-[#EAECEF]">Precise</span>
          <span className="text-[#B0B4BB] hidden sm:inline-block ml-1">(Structured)</span>
        </div>
        <div className="flex items-center">
          <span className="font-bold text-[#EAECEF]">Smooth</span>
          <span className="text-[#B0B4BB] hidden sm:inline-block ml-1">(Natural)</span>
        </div>
      </div>
    </div>
  );
};

export default FlowAdjuster;
